import { orderBy } from 'lodash'
import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../../services/util/date.service'
import { errorHandler } from '../../../../../services/util/error.service'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'

const MENU_ITEMS = [
  '1. Editar',
  '2. Apagar',
  '3. Importação',
  '4. Expedir',
  '5. Aprovar Expedição',
  '6. Reabrir',
  '7. Finalizar',
  '8. Gerar Conferencia',
  '9. Itens Manual',
  '10. Histórico',
]

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_OPERACOES: 'Adquirindo operações',
  GET_MOVIMENTACOES: 'Adquirindo movimentações',
  GET_BY_IDENTIFIER: 'Buscando por identificador',
  REOPEN: 'Reabrindo movimentação',
  DELETE: 'Deletando movimentação',
  FINISH: 'Finalizando movimentação',
  CREATE_CONFERENCIA: 'Criando conferencia da expedição',
  CHECK_HISTORICO: 'Verificando histórico de conferência',
  CHECK_REOPEN: 'Verificando conferência da expedição',
  SUCCESS_DELETE: 'Movimentação deletada com sucesso',
}

const MODAL_INIT_STATE = {
  id: null,
  name: '',
  company_id: '',
  file_type_id: '',
}

const INITIAL_STATE = {
  operacoes: [],
  movimentacoes: [],
  selectedMovimentacao: null,
  modal: { show: false, data: { ...MODAL_INIT_STATE } },
  modalConfirmDelete: { show: false, data: null },
  modalConfirmReopen: { show: false, data: null },
  periodo: getPeriodoMesAtual(),
  identifier: '',
  pathToRedirect: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  successMessage: null,
}

export default function useMovimentacaoExpedicao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const resetModal = () => {
      return {
        show: false,
        data: { ...MODAL_INIT_STATE },
      }
    }

    const toggleModal = show => {
      setState(prevState => ({ ...prevState, modal: { show, data: MODAL_INIT_STATE } }))
    }

    return {
      async deleteMovimentacaoExpedicao(selectedTp, movimentacao, pInicial, pFinal) {
        await EstoqueHttp.deleteMovimentacaoExpedicao(selectedTp, movimentacao.id, pInicial, pFinal)
          .then(() => {
            setState(prevState => ({
              ...prevState,
              movimentacoes: prevState.movimentacoes.filter(mov => mov.id !== movimentacao.id),
              loadingMessage: LOAD_MESSAGE.SUCCESS_DELETE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      async reabrirMovimentacaoExpedicao(selectedTp, movimentacao) {
        await EstoqueHttp.reabrirMovimentacaoExpedicao(selectedTp, movimentacao.id)
          .then(() => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
              successMessage: 'Movimentação de Expedição reaberta com sucesso',
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      async finalizarMovimentacaoExpedicao(selectedTp, movimentacao) {
        await EstoqueHttp.finalizarMovimentacaoExpedicao(selectedTp, movimentacao.id)
          .then(() => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
              successMessage: 'Movimentação de Expedição finalizada com sucesso',
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      async getOperacoesSaida(selectedTp) {
        await EstoqueHttp.getOperacoesEstoqueSaida(selectedTp)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              operacoes: res.filter(r => r.grupo_de_operacao === 'Expedição'),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      async createConferenciaExpedicao(selectedTp, expedicaoId) {
        await EstoqueHttp.createConferenciaExpedicao(selectedTp, expedicaoId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              operacoes: res,
              loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
              successMessage: 'Conferencia da Movimentação de Expedição criada com sucesso',
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Actions

      onInit(selectedTp) {
        if (selectedTp) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
          }))
        }
      },

      onBtnNovo(selectedTp) {
        if (selectedTp) toggleModal(true)
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: resetModal() }))
      },

      onModalSave(movimentacao) {
        setState(prevState => {
          const index = prevState.movimentacoes.findIndex(mov => mov.id === movimentacao.id)
          if (index !== -1) prevState.movimentacoes[index] = movimentacao
          else prevState.movimentacoes.push(movimentacao)
          prevState.movimentacoes = orderBy(prevState.movimentacoes, 'id', 'desc')
          return { ...prevState, modal: resetModal() }
        })
      },

      onMenuItemClicked(item, movimentacao, selectedTp) {
        let path = ''
        switch (item) {
          case '1. Editar':
            setState(prevState => ({ ...prevState, modal: { show: true, data: movimentacao } }))
            break
          case '2. Apagar':
            if (
              !['Aguardando Importação', 'Importado', 'Em Expedição', 'Reaberto'].includes(
                movimentacao.status,
              )
            ) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite apagar a expedição.',
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                modalConfirmDelete: { show: true, data: movimentacao },
              }))
            }
            break
          case '3. Importação':
            if (movimentacao.tipo === 'xml') {
              path = '/main/estoque/movimentacao-estoque-expedicao-importacao-xml'
            } else if (movimentacao.tipo === 'excel') {
              path = '/main/estoque/movimentacao-estoque-expedicao-importacao-excel'
            } else {
              console.log('Não homologado')
            }
            setState(prevState => ({
              ...prevState,
              selectedMovimentacao: movimentacao,
              pathToRedirect: path !== '' ? path : null,
            }))
            break
          case '4. Expedir':
            if (!['Importado', 'Reaberto', 'Em Expedição'].includes(movimentacao.status)) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite manipulação da expedição.',
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                selectedMovimentacao: movimentacao,
                pathToRedirect: '/main/estoque/movimentacao-estoque-expedicao-expedir',
              }))
            }
            break
          case 'Ver Relatório':
            if (
              ![
                'Reaberto',
                'Em Expedição',
                'Expedido',
                'Finalizado',
                'Em Conferencia',
                'Conferido',
              ].includes(movimentacao.status)
            ) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite emissão de relatório.',
              }))
            } else {
              EstoqueHttp.emitirRelatorio(selectedTp, movimentacao.id)
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
              }))
            }
            break
          case '5. Aprovar Expedição':
            if (!['Reaberto', 'Em Expedição', 'Expedido'].includes(movimentacao.status)) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite emissão de relatório.',
              }))
            } else {
              EstoqueHttp.emitirExpedicaoDaMovimentacao(selectedTp, movimentacao.id)
                .then(() => {
                  setState(prevState => ({
                    ...prevState,
                    loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
                    successMessage: 'Expedição aprovada com sucesso',
                  }))
                })
                .catch(err => setState(prevState => ({ ...prevState, errorMessage: err })))
            }
            break
          case '6. Reabrir':
            if (!['Expedido'].includes(movimentacao.status)) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite reabertura da expedição.',
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                selectedMovimentacao: movimentacao,
                loadingMessage: LOAD_MESSAGE.CHECK_REOPEN,
              }))
            }
            break
          case '7. Finalizar':
            if (!['Expedido'].includes(movimentacao.status)) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite finalização da expedição.',
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                selectedMovimentacao: movimentacao,
                loadingMessage: LOAD_MESSAGE.FINISH,
              }))
            }
            break
          case '8. Gerar Conferencia':
            if (!['Finalizado'].includes(movimentacao.status)) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite gerar a conferencia da expedição.',
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                selectedMovimentacao: movimentacao,
                loadingMessage: LOAD_MESSAGE.CREATE_CONFERENCIA,
              }))
            }
            break
          case '9. Itens Manual':
            if (movimentacao.status !== 'Aguardando Importação') {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'O status atual não permite adicionar novos itens.',
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                selectedMovimentacao: movimentacao,
                pathToRedirect: '/main/estoque/movimentacao-estoque-expedicao-itens-manual',
              }))
            }
            break

          case '10. Histórico':
            setState(prevState => ({
              ...prevState,
              selectedMovimentacao: movimentacao,
              loadingMessage: LOAD_MESSAGE.CHECK_HISTORICO,
            }))
            break

          default:
            break
        }
      },

      onPesquisar(pInicial, pFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial: pInicial, dataFinal: pFinal },
          loadingMessage: LOAD_MESSAGE.GET_MOVIMENTACOES,
        }))
      },

      onIdentifierChange(value) {
        setState(prevState => ({ ...prevState, identifier: value }))
      },

      onBuscarByIdentifier(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
          return
        }
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_BY_IDENTIFIER }))
      },

      async checkConferenciaBeforeReopen(selectedTp, movimentacao) {
        await EstoqueHttp.getHistoricoConferenciaExpedicao(selectedTp, movimentacao.id)
          .then(historico => {
            if (historico.beeps && historico.beeps.length) {
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                modalConfirmReopen: { show: true, data: movimentacao },
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.REOPEN,
              }))
            }
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      onModalConfirmReopenClose() {
        setState(prevState => ({
          ...prevState,
          modalConfirmReopen: { show: false, data: null },
        }))
      },

      onModalConfirmReopenOk() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.REOPEN,
          selectedMovimentacao: prevState.modalConfirmReopen.data,
          modalConfirmReopen: { show: false, data: null },
        }))
      },

      async checkHistoricoConferencia(selectedTp, movimentacao) {
        await EstoqueHttp.getHistoricoConferenciaExpedicao(selectedTp, movimentacao.id)
          .then(historico => {
            if (!historico.beeps || !historico.beeps.length) {
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: 'Não existe registros da conferência dessa expedição',
              }))
            } else {
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                pathToRedirect: '/main/estoque/movimentacao-estoque-expedicao-historico',
              }))
            }
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      async getMovimentacaoExpedicaoByIdentifier(selectedTp, identifier, pInicial, pFinal) {
        await EstoqueHttp.getMovimentacaoExpedicaoByIdentifier(selectedTp, identifier, pInicial, pFinal)
          .then(movimentacoes => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              movimentacoes: orderBy([].concat(movimentacoes), 'id', 'desc'),
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          successMessage: null,
          pathToRedirect: null,
        }))
      },

      getMenuItems() {
        return MENU_ITEMS
      },

      onMenuItemEditarClicked(movimentacao) {
        setState(prevState => ({ ...prevState, modal: { show: true, data: movimentacao } }))
      },

      onMenuItemApagarClicked(movimentacao) {
        setState(prevState => ({
          ...prevState,
          modalConfirmDelete: { show: true, data: movimentacao },
        }))
      },

      onModalConfirmDeleteClose() {
        setState(prevState => ({
          ...prevState,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalConfirmDeleteOk() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.DELETE,
          selectedMovimentacao: prevState.modalConfirmDelete.data,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      async getMovimentacoesExpedicao(selectedTp, pInicial, pFinal) {
        await EstoqueHttp.getMovimentacoesExpedicao(selectedTp, pInicial, pFinal)
          .then(movimentacoes => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.GET_OPERACOES,
              movimentacoes: orderBy(movimentacoes, 'id', 'desc'),
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
    }
  }, [])

  return { state, localDispatch }
}
